import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import '../styles.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    email: '',
    transactionHash: '',
    walletAddress: '',
    walletName: '',
    purchaseAmount: '',
    coinType: 'USDC', // Default to USDC
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  // Fetch the user's email when the component mounts
  useEffect(() => {
    const fetchUserEmail = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setError('Please login first');
          navigate('/login');
          return;
        }

        // Use the same endpoint as Profile.js to fetch user data
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/user/profile`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const userEmail = response.data.email;
        if (userEmail) {
          setFormData(prev => ({ ...prev, email: userEmail }));
        } else {
          setError('Unable to fetch your email. Please try again or contact support.');
        }
      } catch (err) {
        console.error('Fetch user email error:', err);
        setError('Error fetching your email: ' + (err.response?.data?.error || err.message));
        if (err.response?.status === 401) {
          navigate('/login');
        }
      }
    };

    fetchUserEmail();
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('Please login first');
        navigate('/login');
        return;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/contact/send-email`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setSuccess(response.data.message || 'Report saved successfully to the database!');
      setFormData({
        email: formData.email, // Keep the email as is
        transactionHash: '',
        walletAddress: '',
        walletName: '',
        purchaseAmount: '',
        coinType: 'USDC',
      });
    } catch (err) {
      console.error('Contact form submission error:', err);
      setError(err.response?.data?.error || 'Failed to save report. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <Header />
      <section className="content-container container my-4">
        <div className="card p-4 mx-auto card-mid-width">
          <h2 className="text-center mb-4">Report Payment Issue</h2>
          {error && <p className="text-danger text-center">{error}</p>}
          {success && <p className="text-success text-center">{success}</p>}
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Your Email</label>
              <input
                type="email"
                id="email"
                name="email"
                className="form-control"
                value={formData.email}
                readOnly // Make the field read-only
                required
                disabled={loading}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="transactionHash" className="form-label">Transaction Hash</label>
              <input
                type="text"
                id="transactionHash"
                name="transactionHash"
                className="form-control"
                value={formData.transactionHash}
                onChange={handleChange}
                placeholder="Enter transaction hash"
                required
                disabled={loading}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="walletAddress" className="form-label">Your Wallet Address</label>
              <input
                type="text"
                id="walletAddress"
                name="walletAddress"
                className="form-control"
                value={formData.walletAddress}
                onChange={handleChange}
                placeholder="Enter wallet address"
                required
                disabled={loading}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="walletName" className="form-label">Your Wallet Name</label>
              <input
                type="text"
                id="walletName"
                name="walletName"
                className="form-control"
                value={formData.walletName}
                onChange={handleChange}
                placeholder="Enter wallet name (e.g., Phantom, Solflare, Trust Wallet, MetaMask)"
                required
                disabled={loading}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="purchaseAmount" className="form-label">Purchase Amount in USD$</label>
              <input
                type="number"
                id="purchaseAmount"
                name="purchaseAmount"
                className="form-control"
                value={formData.purchaseAmount}
                onChange={handleChange}
                placeholder="Enter purchase amount"
                min="0"
                step="0.01"
                required
                disabled={loading}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="coinType" className="form-label">Type of Coin Sent</label>
              <select
                id="coinType"
                name="coinType"
                className="form-control"
                value={formData.coinType}
                onChange={handleChange}
                required
                disabled={loading}
              >
                <option value="USDC">USDC</option>
                <option value="USDT">USDT</option>
                <option value="SOL">SOL</option>
              </select>
            </div>
            <button type="submit" className="btn btn-primary w-100" disabled={loading}>
              {loading ? 'Saving...' : 'Send  Report'}
            </button>
          </form>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Contact;
